import React, { useState } from 'react'
import DashboardHeader from '../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../DashboardReuseAbleComponents/DashboardSideMenu';
import ShowProfileModal from '../DashboardFileManagement/CardDetail/ShowProfileModal';
import { Link } from 'react-router-dom';

// Styles
import styles from "./Settings.module.css";

// Images
import arrowIcon from "./../../../assets/img/DashboardICons/ArrowRounded.svg"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


const Settings = () => {
    const history = useHistory();
    const [modalShow, setModalShow] = useState(false);

    return (
        <>
            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <div className='container-fluid'>
                <div className='row'>
                    <div className="col-md-9" >
                        <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                            <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                            <div
                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                dir="rtl"
                            >
                                <div className='w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                    <a href='#' onClick={history.goBack}>
                                        <img className='ms-2' src={arrowIcon} alt="icon" />
                                    </a>
                                    <div className={styles.text1}>
                                        تنظمیات سایت
                                    </div>
                                </div>
                            </div>

                            {/* Box Page */}
                            <div dir="rtl" className="d-flex justify-content-between align-items-center flex-wrap px-2 py-3 mx-4 my-4">
                                {/* <Link to="/blog-dashboard" className={`${styles.settings_page_box} text-center mb-4`}>
                                    وبلاگ
                                </Link> */}
                                <Link to="/setting-about" className={`${styles.settings_page_box} text-center mb-4`}>
                                    درباره ما
                                </Link>
                                <Link to="/setting-contact" className={`${styles.settings_page_box} text-center mb-4`}>
                                    تماس با ما
                                </Link>
                                <Link to="/banner-1" className={`${styles.settings_page_box} text-center mb-4`}>
                                    بنر اول
                                </Link>
                                <Link to="/banner-2" className={`${styles.settings_page_box} text-center mb-4`}>
                                    بنر دوم
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-3'>
                        {/* sideMenu starts */}
                        <DashboardSideMenu />
                        {/* sideMenu ends */}
                    </div>
                </div>
            </div>
        </>
    )

}

export default Settings